module.exports = __webpack_public_path__ + "img/Trailer-Outline.d23f2bb0.png";